import React, { Component } from "react";
import Routes from "./Routes";
import NavbarMain from "./Navbar_main";
import Footer from "./components/Footer/Footer";
import Auth from "./auth/Auth";
import { withRouter } from "react-router-dom";
import SEO from "./components/MetaHelmet/meta";
import { withTranslation } from 'react-i18next';

// URL mapping với translation keys
const URL_ARRAY = [
  { url: "/ja/service-management-guide", titleKey: "titles.service_management" },
  { url: "/huong-dan-quan-ly-dich-vu", titleKey: "titles.service_management" },
  { url: "/huong-dan-dang-ky-su-kien", titleKey: "titles.event_registration" },
  { url: "/ja/event-registration-guide", titleKey: "titles.event_registration" },
  { url: "/huong-dan-luu-pass-wifi", titleKey: "titles.wifi_password" },
  { url: "/ja/guide-for-saving-wifi-password", titleKey: "titles.wifi_password" },
  { url: "/huong-dan-tao-trac-nghiem", titleKey: "titles.quiz_creation" },
  { url: "/ja/guide-for-creating-quizzes", titleKey: "titles.quiz_creation" },
  { url: "/huong-dan-tao-vcard", titleKey: "titles.vcard_online" },
  { url: "/ja/guide-for-creating-vcard", titleKey: "titles.vcard_online" },
  { url: "/huong-dan-tao-pdf", titleKey: "titles.pdf_qr_code" },
  { url: "/ja/guide-for-creating-pdf", titleKey: "titles.pdf_qr_code" },
  { url: "/chinh-sach-bao-mat", titleKey: "titles.privacy_policy" },
  { url: "/ja/privacy-policy", titleKey: "titles.privacy_policy" },
  { url: "/service-pack", titleKey: "titles.service_package" },
  { url: "/ja/service-pack", titleKey: "titles.service_package" },
  { url: '/blog', titleKey: 'titles.news' },
  { url: '/ja/blog', titleKey: 'titles.news' },
]

const auth = new Auth();

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shouldShowTheButton: false,
    };
    this.navbar = React.createRef();
  }
  async componentDidMount() {
    this.checkParams();
    this.handleRouteSignal();
  }

  async componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.checkParams();
      this.handleRouteSignal();
    }
  }

  handleRouteSignal() {
    const { pathname } = this.props.location;
    const isBlog = pathname.includes('/blog');
    const isDashboard = pathname.includes('/dashboard');
    
    // Clear any pending signal timeout
    if (this.signalTimeout) {
      clearTimeout(this.signalTimeout);
    }
    if (this.safetyTimeout) {
      clearTimeout(this.safetyTimeout);
    }
    
    // Always clear signal attribute on path change
    document.body.removeAttribute('data-content-ready');

    // Safety fallback: Force signal ready after 15s no matter what
    this.safetyTimeout = setTimeout(() => {
      document.body.setAttribute('data-content-ready', 'true');
    }, 15000);

    if (!isBlog && !isDashboard) {
      // Static pages signal ready after a short tick
      this.signalTimeout = setTimeout(() => {
        if (this.props.location.pathname === pathname) {
          document.body.setAttribute('data-content-ready', 'true');
          if (this.safetyTimeout) clearTimeout(this.safetyTimeout);
        }
      }, 1000); 
    }
  }
  checkParams() {
    const { t } = this.props;
    const { pathname } = this.props.location;
    const result = URL_ARRAY.filter((item) => item.url === pathname);

    let pageTitle = t('adverstise.feature.title'); // Default title from translation

    if (result?.length > 0) {
      pageTitle = 'QR CODE - ' + t(result[0].titleKey);
    }

    console.log(pageTitle);
    return pageTitle;
  }
  render() {
    const { pathname } = this.props.location;
    const currentPath = pathname || window.location.pathname;
    const isHomePath = currentPath === '/' || /^\/(ja|vi|en|ko|zh|hi|de|fr|pt|es|it|ar|ru|id|ms|th|lo|mm)\/?$/.test(currentPath);
    const isBlogPath = !isHomePath && (currentPath.includes('/blog') || 
                      /^\/(huong-dan|ja|vi|en|ko|zh|hi|de|fr|pt|es|it|ar|ru|id|ms|th|lo|mm)/.test(currentPath));
    const seoDescriptionKey = 'adverstise.feature.description';
    const translatedSeoDescription = this.props.t(seoDescriptionKey);
    const seoDescriptionFallback =
      this.props.i18n?.language === 'vi'
        ? 'Tạo mã QR miễn phí cho website, danh thiếp, WiFi, PDF, menu nhà hàng và quản lý tài sản trực tuyến nhanh chóng.'
        : 'Create free QR codes for websites, vCards, WiFi, PDF, menus, and asset management in seconds.';
    const seoDescription =
      translatedSeoDescription && translatedSeoDescription !== seoDescriptionKey
        ? translatedSeoDescription
        : seoDescriptionFallback;

    return (
      <div>

        {!isBlogPath && (
          <SEO
            title={this.checkParams()}
            description={seoDescription}
          />
        )}
        {!/^\/dashboard/.test(this.props.location.pathname) && (
          <NavbarMain
            shouldShowTheButton={this.state.shouldShowTheButton}
            auth={auth}
            ref={this.navbar}
          />
        )}
        {/* <Routes onMount={this.someFunc} onRerender={() => { this.setState(this.state) }} /> */}
        <div className="main-content">
          <Routes onMount={this.onChildMount} navbar={this.navbar} />
        </div>
        {!/^\/dashboard/.test(this.props.location.pathname) && <Footer />}
      </div>
    );
  }

  onChildMount = (shouldShowTheButton) =>
    this.setState({
      shouldShowTheButton,
    });
}

export default withRouter(withTranslation()(App));
